import { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function ForgotPassword({ isOpen, onClose }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, sent, error
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    
    try {
      const response = await fetch(
        'https://r7ej0e9i28.execute-api.ap-southeast-2.amazonaws.com/dev/forgotpassword',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email }),
        }
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to process request');
      }

      setStatus('sent');
    } catch (error) {
      setStatus('error');
      setErrorMessage(error.message);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 z-50 flex md:justify-center md:items-center">
      <div className="bg-white w-full md:rounded-lg md:shadow-xl md:max-w-md md:m-auto h-full md:h-auto">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-xl font-semibold text-gray-900">Reset Password</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <div className="p-6 md:p-6 bg-gray-50">
          {status === 'sent' ? (
            <div className="text-center">
              <p className="text-sm text-gray-600 mb-4">
                If an account exists with this email, you will receive password reset instructions shortly.
              </p>
              <button
                onClick={onClose}
                className="w-full bg-slate-900 text-white px-4 py-2 rounded-md hover:bg-slate-800"
              >
                Close
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="mb-6">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-slate-500 focus:border-slate-500"
                  required
                />
              </div>

              {status === 'error' && (
                <p className="text-sm text-red-600 mb-4">{errorMessage}</p>
              )}

              <button
                type="submit"
                disabled={status === 'loading'}
                className="w-full bg-slate-900 text-white px-4 py-2 rounded-md hover:bg-slate-800 disabled:bg-slate-400"
              >
                {status === 'loading' ? 'Sending...' : 'Reset Password'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
} 